/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CompleteDatevConnectionRequest,
  CreateDatevExportRequest,
  DatevExportDto,
  DatevStatusDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiDatevExportController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-datev-export-controller
   * @name GetDatevStatus
   * @request GET:/api/v1/export/datev
   */
  getDatevStatus = (params: RequestParams = {}) =>
    this.http.request<DatevStatusDto, any>({
      path: `/v1/export/datev`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getDatevStatusPath = '/v1/export/datev'
  static getDatevStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags api-datev-export-controller
   * @name CreateExport
   * @request POST:/api/v1/export/datev
   */
  createExport = (data: CreateDatevExportRequest, params: RequestParams = {}) =>
    this.http.request<DatevExportDto, any>({
      path: `/v1/export/datev`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createExportPath = '/v1/export/datev'
  static createExportMethod = 'POST'
  /**
   * No description
   *
   * @tags api-datev-export-controller
   * @name RevokeDatevTokens
   * @request POST:/api/v1/export/datev/revoke
   */
  revokeDatevTokens = (params: RequestParams = {}) =>
    this.http.request<DatevStatusDto, any>({
      path: `/v1/export/datev/revoke`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static revokeDatevTokensPath = '/v1/export/datev/revoke'
  static revokeDatevTokensMethod = 'POST'
  /**
   * No description
   *
   * @tags api-datev-export-controller
   * @name CompleteDatevConnection
   * @request POST:/api/v1/export/datev/connection
   */
  completeDatevConnection = (data: CompleteDatevConnectionRequest, params: RequestParams = {}) =>
    this.http.request<DatevStatusDto, any>({
      path: `/v1/export/datev/connection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static completeDatevConnectionPath = '/v1/export/datev/connection'
  static completeDatevConnectionMethod = 'POST'
  /**
   * No description
   *
   * @tags api-datev-export-controller
   * @name SetClientId
   * @request POST:/api/v1/export/datev/clients/{clientId}
   */
  setClientId = (clientId: string, params: RequestParams = {}) =>
    this.http.request<DatevStatusDto, any>({
      path: `/v1/export/datev/clients/${clientId}`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static setClientIdPath = '/v1/export/datev/clients/${clientId}'
  static setClientIdMethod = 'POST'
  /**
   * No description
   *
   * @tags api-datev-export-controller
   * @name GetExportStatus
   * @request GET:/api/v1/export/datev/{exportId}/status
   */
  getExportStatus = (exportId: string, params: RequestParams = {}) =>
    this.http.request<DatevExportDto, any>({
      path: `/v1/export/datev/${exportId}/status`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getExportStatusPath = '/v1/export/datev/${exportId}/status'
  static getExportStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags api-datev-export-controller
   * @name DownloadExportZip
   * @request GET:/api/v1/export/datev/{exportId}/files
   */
  downloadExportZip = (exportId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/export/datev/${exportId}/files`,
      method: 'GET',
      ...params,
    })

  static downloadExportZipPath = '/v1/export/datev/${exportId}/files'
  static downloadExportZipMethod = 'GET'
}
